import { yupResolver } from '@hookform/resolvers/yup';
import { Button, HfInput } from '@myosh/odin-components';
import { type FieldValues, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { checkIdp } from '../helpers/check-idp';
import Footer from './footer.component';
import Sidebar from './sidebar.component';

export interface LoginFormProps {
  setIdp: (domain: string) => void;
}

const schema = yup.object().shape({
  email: yup.string().required('Email is a required field').email(),
});

export default function LoginForm({ setIdp }: LoginFormProps) {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FieldValues>({
    resolver: yupResolver(schema) as never,
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
  });

  const loginButtonStyles = 'm-0 mt-6';

  const onSubmit = async (data: FieldValues) => {
    if (data.email !== '') {
      const idp = await checkIdp(data.email);
      return setIdp(idp);
    }
  };

  return (
    <div className="myl-login-layout flex h-full min-h-screen w-full flex-col sm:flex-row">
      <Sidebar />
      <div className="bg-mono-1 flex min-w-0 flex-1 flex-col">
        <div className="flex max-w-sm flex-1 flex-col justify-center px-8 pb-12 md:ml-24 md:px-0">
          <h2 className="mt-8 mb-6 text-6xl font-bold sm:mt-12">Welcome</h2>
          <p className="mb-4 sm:text-xl md:text-2xl">Log in to myosh</p>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="h-[50px]">
              <HfInput
                name="email"
                type="email"
                placeholder="Enter email"
                control={control}
                error={errors.email?.message as string | undefined}
                enableDebounce={false}
              />
            </div>
            <div className="flex flex-row">
              <Button type="primary" htmlType="submit" classNames={loginButtonStyles}>
                Log In
              </Button>
            </div>
          </form>
        </div>
        <Footer />
      </div>
    </div>
  );
}
